/**
 * Low-level HTTP API client. Auth is carried by HttpOnly cookies, so there is no token to store.
 * Writes send the CSRF token the server handed out at sign-in.
 */

export const backendURL = import.meta.env.VITE_API_URL || ''

let csrfToken = ''
export const setCsrfToken = (token) => {
  csrfToken = token || ''
}

export const UNAUTHORIZED_EVENT = 'uniqpay:unauthorized'
const SESSION_CODES = ['session_expired', 'gate_required', 'not_signed_in']

/** Reject with a plain object: { status, code, error, fields }. */
const responseHandler = async (resp) => {
  const text = await resp.text()
  let body = {}
  try {
    body = text ? JSON.parse(text) : {}
  } catch {
    body = {}
  }
  if (resp.status >= 200 && resp.status < 300) return body
  const failure = { status: resp.status, code: body.code, error: body.error, fields: body.fields }
  if (resp.status === 401 && (!body.code || SESSION_CODES.includes(body.code))) {
    window.dispatchEvent(new CustomEvent(UNAUTHORIZED_EVENT, { detail: failure }))
  }
  return Promise.reject(failure)
}

const errorHandler = (err) => {
  if (!err || err.status === undefined) console.error('API Error:', err)
  return Promise.reject(err)
}

const send = (method, url, data, raw = false) => {
  const options = { method, headers: { Accept: 'application/json' } }
  if (method === 'GET') options.cache = 'no-store'
  if (method !== 'GET' && csrfToken) options.headers['X-CSRF-Token'] = csrfToken
  if (data !== undefined) {
    options.body = raw ? data : JSON.stringify(data)
    if (!raw) options.headers['Content-Type'] = 'application/json'
  }
  return fetch(backendURL + url, options).then(responseHandler).catch(errorHandler)
}

export const GET = (url) => send('GET', url)
export const POST = (url, data = {}, raw = false) => send('POST', url, data, raw)
export const PUT = (url, data) => send('PUT', url, data)
export const DELETE = (url) => send('DELETE', url)
